import {
    LayoutDashboard, ShoppingCart, Package, Sparkles, Receipt,
    ShoppingBag, WalletCards, Calculator, Users, Settings, Crown
} from 'lucide-react';

/**
 * Factory to determine the sidebar menu items based on the user's role.
 * 
 * Role 4 is ACCOUNTANT, which should only see the 'Hub' page.
 */
export const getSidebarMenu = (profile) => {
    const roleId = profile?.colaborador?.role_id ?? profile?.role_id;

    const menuItems = [
        { id: 'hub', label: 'Hub', icon: LayoutDashboard, path: '/hub' },
        { id: 'pos', label: 'Punto de Venta', icon: ShoppingCart, path: '/pos' },
        { id: 'products', label: 'Productos', icon: Package, path: '/stock' },
        { id: 'services', label: 'Servicios', icon: Sparkles, path: '/services' },
        { id: 'invoice', label: 'Facturación', icon: Receipt, path: '/invoice' },
        { id: 'compras', label: 'Compras/Gastos', icon: ShoppingBag, path: '/compras' },
        { id: 'accounts', label: 'Cartera', icon: WalletCards, path: '/accounts-management' },
        { id: 'accounting', label: 'Contabilidad', icon: Calculator, path: '/accounting' },
        { id: 'terceros', label: 'Terceros', icon: Users, path: '/terceros' },
    ];

    if (roleId === 1) {
        menuItems.push({ id: 'operations', label: 'Operaciones', icon: Settings, path: '/operations' });
    }

    const bottomItems = [];

    //{ id: 'planes', label: 'Suscripción', icon: Crown, path: '/planes' },

    // If the role is Cashier (3), no sidebar menu items
    if (roleId === 3) {
        return {
            menuItems: [],
            bottomItems: []
        };
    }

    // If the role is Accountant (4), restrict menu to Hub only and no bottom items
    if (roleId === 4) {
        return {
            menuItems: menuItems.filter(item => item.id === 'hub'),
            bottomItems: []
        };
    }

    return {
        menuItems,
        bottomItems
    };
};
